import { render, staticRenderFns } from "./jsmx.vue?vue&type=template&id=353de9f8&scoped=true"
import script from "./jsmx.vue?vue&type=script&lang=js"
export * from "./jsmx.vue?vue&type=script&lang=js"
import style0 from "./jsmx.vue?vue&type=style&index=0&id=353de9f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353de9f8",
  null
  
)

export default component.exports